"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.base */
//================================================================

var MapContainer_1 = require("./MapContainer");

var LogicError_1 = require("../../exception/LogicError");
/**
 * Base class for Unique-key Map Containers.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var UniqueMap =
/** @class */
function (_super) {
  __extends(UniqueMap, _super);

  function UniqueMap() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  UniqueMap.prototype.count = function (key) {
    return this.find(key).equals(this.end()) ? 0 : 1;
  };
  /**
   * Get a value.
   *
   * @param key Key to search for.
   * @return The value mapped by the key.
   */


  UniqueMap.prototype.get = function (key) {
    var it = this.find(key);
    if (it.equals(this.end()) === true) throw new LogicError_1.OutOfRange("Error on std." + this.constructor.name + ".get(): unable to find the matched key -> " + key + ".");
    return it.second;
  };
  /**
   * Set a value with key.
   *
   * @param key Key to be mapped or search for.
   * @param val Value to insert or assign.
   */


  UniqueMap.prototype.set = function (key, val) {
    this.insert_or_assign(key, val);
  };

  UniqueMap.prototype.insert = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return _super.prototype.insert.apply(this, __spread(args));
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Insert_by_range = function (first, last) {
    for (var it = first; !it.equals(last); it = it.next()) {
      this.emplace(it.value.first, it.value.second);
    }
  };

  UniqueMap.prototype.insert_or_assign = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (args.length === 2) {
      return this._Insert_or_assign_with_key_value(args[0], args[1]);
    } else if (args.length === 3) {
      // INSERT OR ASSIGN AN ELEMENT
      return this._Insert_or_assign_with_hint(args[0], args[1], args[2]);
    }
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Insert_or_assign_with_key_value = function (key, value) {
    var ret = this.emplace(key, value);
    if (ret.second === false) ret.first.second = value;
    return ret;
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Insert_or_assign_with_hint = function (hint, key, value) {
    var ret = this.emplace_hint(hint, key, value);
    if (ret.second !== value) ret.second = value;
    return ret;
  };

  UniqueMap.prototype.extract = function (param) {
    if (param instanceof this.end().constructor) return this._Extract_by_iterator(param);else return this._Extract_by_key(param);
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Extract_by_key = function (key) {
    var it = this.find(key);
    if (it.equals(this.end()) === true) throw new LogicError_1.OutOfRange("Error on std." + this.constructor.name + ".extract(): unable to find the matched key -> " + key + ".");
    var ret = it.value;

    this._Erase_by_range(it);

    return ret;
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Extract_by_iterator = function (it) {
    if (it.equals(this.end()) === true) return this.end();

    this._Erase_by_range(it);

    return it;
  };
  /**
   * @hidden
   */


  UniqueMap.prototype._Erase_by_key = function (key) {
    var it = this.find(key);
    if (it.equals(this.end()) === true) return 0;

    this._Erase_by_range(it);

    return 1;
  };
  /* ---------------------------------------------------------
      UTILITY
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  UniqueMap.prototype.merge = function (source) {
    for (var it = source.begin(); !it.equals(source.end());) {
      if (this.has(it.first) === false) {
        this.insert(it.value);
        it = source.erase(it);
      } else it = it.next();
    }
  };

  return UniqueMap;
}(MapContainer_1.MapContainer);

exports.UniqueMap = UniqueMap;